import { http } from '@/lib/ats-https';

const pushApplicationToHris = async (params) => {
  const response = await http.post(
    `/ats_applications/${params?.application_id}/hris_employees`,
    params
  );
  return response;
};

export const HRIS_API_SERVICE = {
  pushApplicationToHris,
};
